import {
  PARTNERSHIP_RESORTS_LOAD_SUCCESS,
  PARTNERSHIP_CHANNELS_LOAD_SUCCESS,
  PARTNERSHIP_RESORTS_SELECT,
  PARTNERSHIP_PARTNERS_CHANGE,
  PARTNERSHIP_SELECTION_CHANGE
} from "../actions";
import { projectById, projectByCode } from "../services/project";

const PARTNERSHIP_SHAPE = {
  resorts: {
    list: {
      all: [],
      byId: {},
      selected: null
    }
  },
  merchants: {
    list: {
      all: [],
      byId: {},
      selecteds: []
    }
  }
};

export default (state = PARTNERSHIP_SHAPE, action) => {
  switch (action.type) {
    case PARTNERSHIP_RESORTS_LOAD_SUCCESS:
      return {
        ...state,
        resorts: {
          ...state.resorts,
          list: {
            ...state.resorts.list,
            ...projectById(action.resorts)
          }
        }
      };
    case PARTNERSHIP_CHANNELS_LOAD_SUCCESS:
      return {
        ...state,
        channels: action.channels
      };
    case PARTNERSHIP_RESORTS_SELECT:
      return {
        ...state,
        resorts: {
          ...state.resorts,
          list: {
            ...state.resorts.list,
            selected: action.resort
          }
        },
        merchants: {
          ...state.merchants,
          list: {
            ...state.merchants.list,
            ...projectByCode(action.merchants),
            selecteds: action.selecteds
          }
        }
      };

    case PARTNERSHIP_PARTNERS_CHANGE:
      return {
        ...state,
        merchants: {
          ...state.merchants,
          list: {
            ...state.merchants.list,
            selecteds: action.partners
          }
        }
      };
    case PARTNERSHIP_SELECTION_CHANGE:
      return {
        ...state,
        merchants: {
          ...state.merchants,
          list: {
            ...state.merchants.list,
            selection: action.selection
          }
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/partnership/reducers.js